import React from 'react';
import { IconProps } from '../types';
const MinecraftFlowerPot: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="2" width="1" height="1" fill="rgba(51, 22, 16, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(53, 23, 17, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(53, 23, 17, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(58, 24, 17, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(58, 26, 20, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(56, 25, 18, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(114, 57, 43, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(121, 64, 48, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(122, 70, 53, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(114, 57, 43, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(56, 24, 20, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(56, 24, 16, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(58, 26, 20, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(114, 57, 43, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(121, 64, 48, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(122, 70, 53, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(114, 57, 43, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(58, 26, 20, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(84, 33, 22, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(78, 39, 30, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(106, 49, 35, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(78, 39, 30, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(84, 33, 22, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(78, 39, 30, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(78, 39, 30, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(78, 39, 30, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(78, 39, 30, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(78, 39, 30, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(78, 39, 30, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(84, 33, 22, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(165, 111, 94, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(86, 35, 23, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(165, 111, 94, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(154, 102, 85, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(138, 81, 67, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(122, 65, 49, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(83, 31, 21, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(83, 32, 23, 255)" />
</svg>);
export default MinecraftFlowerPot;